// extracted by mini-css-extract-plugin
module.exports = {"list":"W2HowItWorks_list__11U7y","list__item":"W2HowItWorks_list__item__JvlwE"};